import { useEffect, useMemo } from "react";
import { StatSummary, useGetCallCenterStats } from "services/call-center-service";
import { useAccountChange } from "./useAccountChange";
import { formatSeconds } from "utils/formatWaitTime";

interface Stats {
  avg: string;
  min: string;
  max: string;
}

export const useQueueWaitTimes = (): Stats => {
  const { data: response, refetch: refetchQueueWaitTimes } = useGetCallCenterStats();

    const statObj = response?.data?.summary?.[0]

  const stats: Stats = useMemo(() => {
    return {
      avg: formatSeconds(Number(statObj?.avg_wait_time ?? 0)),
      min: formatSeconds(Number(statObj?.min_wait_time ?? 0)),
      max: formatSeconds(Number(statObj?.max_wait_time ?? 0)),
    };
  }, [statObj]);

  useAccountChange(true, refetchQueueWaitTimes);

    useEffect(() => {
    const interval = setInterval(() => {
      refetchQueueWaitTimes();
    }, 60_000); 

    return () => {
      clearInterval(interval);
    };
  }, []);

  return stats;
};